// ─── Exibição de datetimes em horário de São Paulo (UTC-3) ─────────────────────
// O backend grava tudo em UTC. As respostas do starter-pack vêm sem sufixo de
// fuso (MySQL devolve naive); as do gg-hub vêm com fuso (UTCDateTime). Este
// helper interpreta ambos como UTC e formata em America/Sao_Paulo.

import { formatInTimeZone } from "date-fns-tz";

export const SP_TZ = "America/Sao_Paulo";

/** Interpreta uma string ISO como UTC quando ela não traz fuso (backend naive).
 * Strings com Z ou offset (+/-HH:MM) são parseadas normalmente. */
export const parseAsUtc = (iso: string | null | undefined): Date => {
  if (!iso) return new Date(NaN);
  // Tem sufixo Z, +HH:MM ou -HH:MM no fim → já é um instante absoluto.
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(iso)) return new Date(iso);
  // Sem fuso → assume UTC (anexa Z).
  return new Date(`${iso}Z`);
};

/** Formata um ISO (UTC) em horário de São Paulo, usando um pattern do date-fns
 * (ex.: "dd/MM/yyyy", "dd/MM/yyyy HH:mm"). Retorna "" se o valor for vazio ou
 * inválido. */
export const formatSp = (iso: string | null | undefined, pattern: string): string => {
  if (!iso) return "";
  const d = parseAsUtc(iso);
  if (isNaN(d.getTime())) return "";
  return formatInTimeZone(d, SP_TZ, pattern);
};